import createPersistedState from 'vuex-persistedstate';
import Vue from 'vue';
import Vuex from 'vuex';
import tree from './tree';
import user from './user';
import tags from './tags';
import flows from './flows';
import notes from './notes';
import cards from './cards';
import teams from './teams';
import topics from './topics';
import spaces from './spaces';
import signin from './signin';
import signup from './signup';
import columns from './columns';
import confirm from './confirm';
import comments from './comments';
import assignees from './assignees';
import invitation from './invitation';
import milestones from './milestones';
import space_teams from './space_teams';
import attachments from './attachments';
import subscribers from './subscribers';
import team_members from './team_members';
import space_members from './space_members';
import topic_members from './topic_members';
import note_versions from './note_versions';
import configurations from './configurations';
import reset_password from './reset_password';
import saved_searches from './saved_searches';

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        tree,
        user,
        tags,
        flows,
        teams,
        notes,
        cards,
        topics,
        spaces,
        signin,
        signup,
        confirm,
        columns,
        comments,
        assignees,
        invitation,
        milestones,
        attachments,
        subscribers,
        space_teams,
        team_members,
        note_versions,
        space_members,
        topic_members,
        configurations,
        reset_password,
        saved_searches,
    },
    plugins: [createPersistedState({
        paths: [
            'user.token',
            'user.user',
            'configurations',
            'tree.open_notes',
            'spaces.last_page',
            'tree.open_collections',
            'columns.collapsed_columns',
        ],
    })],
});
